import jQuery from 'jquery'
window.$ = window.jQuery = jQuery
export default jQuery
